import React from 'react';
import {
    Box,

    Typography
} from '@mui/material';
import i18n from '../../i18n';
import { RuleEditor } from '../../rulelang/editor/RuleEditor';

// @mui

export default class DialogRulesField extends React.Component {
    // field, value, onChange
    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }

    handleChange(value) {
        this.props.onChange(this.props.field.id, value);
        this.setState({ open: false });
    }

    render() {
        const translatedLabel = i18n.t(
            `columns.${this.props.field.label}Editor`
        );
        const { value } = this.props;
        console.log("Current value:", value);
        const variables = [
            "request_amount", "request_currency", "card_country",
            "is_card_bank_blacklisted", "approve_rate_{gatewayname}"
        ];
        const varTypes = new Map([
            ["request_amount", "d"],
            ["request_currency", "s"],
            ["card_country", "s"],
            ["is_card_bank_blacklisted", "b"],
            ["approve_rate_{gatewayname}", "d"],
        ]);
        const varDocs = new Map([
            ["request_amount", "**request_amount**\n\n• source: request\n• type: integer → `%d`\n• desc: cents, before conversions"],
            ["card_country", "**card_country**\n\n• source: db by PAN\n• type: string → `%s`\n• desc: ISO alpha-2, lowercase"],
        ]);
        return (
            <Box width="500px" padding="16px">
                <Typography variant="body2" color="textSecondary" gutterBottom>
                    {translatedLabel}
                </Typography>
                <RuleEditor
                    value={value}
                    onChange={(newCode, meta) => {
                        this.handleChange(newCode);
                        console.log("Errors:", meta.errors);
                        console.log("References:", meta.references);
                    }}
                    variables={variables}
                    varTypes={varTypes}
                    varDocs={varDocs}
                    height="360px"
                />
            </Box>
            // <>
            //     <Button onClick={() => this.setState({ open: true })}>
            //         {translatedLabel}
            //     </Button>
            //     <Dialog
            //         open={this.state.open}
            //         onClose={this.handleClose}
            //         aria-labelledby="form-dialog-title"
            //     >
            //         <DialogTitle id="form-dialog-title">Edit rules</DialogTitle>
            //         <DialogContent>
            //             <DialogContentText>
            //                 To edit rules, please enter the rules in the
            //                 following format:
            //                 <br />
            //                 <br />
            //                 <BlockComponent
            //                     onSave={this.handleChange.bind(this)}
            //                     onCancel={() => this.setState({ open: false })}
            //                     tree={convertToTree(this.props.value)}
            //                 />
            //             </DialogContentText>
            //         </DialogContent>
            //         <DialogActions>
            //             <Button onClick={() => this.setState({ open: false })}>
            //                 Cancel
            //             </Button>
            //         </DialogActions>
            //     </Dialog>
            // </>
        );
    }
}
